<template>
  <AppModal
    v-bind="$attrs"
    :title="title"
    content-class="attention-dialog"
    no-maximized
    show-close-btn
    @close="$emit('close', $event)"
    @hide="$emit('hide', $event)"
  >
    <div
      v-if="img"
      :class="['pic', picBlockClass]"
    >
      <q-img
        :src="require(`assets/${img}`)"
        :width="imgWidth"
      />
    </div>
    <slot/>
    <template
      v-if="$slots.footer"
      #footer
    >
      <div class="full-width q-px-lg q-pb-lg">
        <div class="row justify-between q-gutter-md">
          <slot name="footer"/>
        </div>
      </div>
    </template>
  </AppModal>
</template>

<script>
import AppModal from 'common/components/AppModal';

export default {
  name: 'AttentionDialog',
  components: { AppModal },
  props: {
    img: {
      type: [String, Boolean],
      default: 'trash.svg',
    },
    imgWidth: {
      type: String,
      default: '180px',
    },
    picBlockClass: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.attention-dialog {
  width: 341px;

  .pic {
    background: $grey-6;
    text-align: center;

    .q-img {
      margin-top: 10px;
    }
  }

  .modal-header {
    border: none;
    background: $grey-6;
    align-items: start;
  }
}
</style>
